import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { UnauthorizedFunction } from '../../utils/UtilsFunction';

/**
 * Async thunk to fetch the user's project data from the API.
 * Calls the UnauthorizedFunction if the response is unsuccessful.
 */
export const get_my_project_data = createAsyncThunk(
  'my_project',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token'); // Retrieve authentication token from local storage

      // API call to fetch project data
      const response = await fetch(
        process.env.REACT_APP_BASE_URL + 'experience',
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`, // Include authorization header
          },
        }
      );

      const res = await response.json();

      if (!res.success) {
        UnauthorizedFunction(res); // Handle unauthorized access
      }

      return res;
    } catch (error) {
      console.error('Error fetching recent projects:', error);
      return rejectWithValue(error.message);
    }
  }
);

/**
 * Initial state for the MyProject slice.
 * - `my_project`: Stores the fetched project data.
 * - `my_project_loading`: Boolean flag to track loading state.
 */
const initialState = {
  my_project: [],
  my_project_loading: false,
};

/**
 * Redux slice to manage the user's project data state.
 * Uses extraReducers to handle async thunk actions.
 */
const MyProjectSlice = createSlice({
  name: 'data',
  initialState,
  extraReducers: (builder) => {
    builder
      // Handling API call pending state
      .addCase(get_my_project_data.pending, (state) => {
        state.my_project_loading = true; // Set loading state to true
      })

      // Handling API call success response
      .addCase(get_my_project_data.fulfilled, (state, action) => {
        state.my_project_loading = false;
        state.my_project = action.payload?.success ? action.payload.data : [];
      })

      // Handling API call failure response
      .addCase(get_my_project_data.rejected, (state) => {
        state.my_project_loading = false; // Set loading state to false on failure
      });
  },
});

export default MyProjectSlice.reducer;
